interface BannerProps {
  imageSrc: string;
  imageAlt: string;
  className?: string;
  onClick?: () => void;
}

export const Banner: React.FC<BannerProps> = ({ imageSrc, imageAlt, className = "", onClick }) => (
  <div className={`w-full ${className} ${onClick ? "cursor-pointer" : ""}`} onClick={onClick}>
    <div className="relative">
      <img src={imageSrc} alt={imageAlt} className="mx-auto" />
    </div>
  </div>
);
